import { configureStore } from '@reduxjs/toolkit';
import { appReducer } from './app/reducer';
import { cleanersReducer } from './cleaners/reducer';
import createSagaMiddleware from 'redux-saga';
import { rootSaga } from './saga';
import { mapReducer } from './map/reducer';
import { bookingsReducer } from './bookings/reducer';
import { chatReducer } from './chat/reducer';
import { reviewReducer } from './reviews/reducer';
import { persistStore } from 'redux-persist';
import { cardsReducer } from './cards/reducer';

const sagaMiddleware = createSagaMiddleware();

const rootReducer = {
  app: appReducer,
  cleaners: cleanersReducer,
  map: mapReducer,
  bookings: bookingsReducer,
  chat: chatReducer,
  reviews: reviewReducer,
  cards: cardsReducer,
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
});

export const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
